import * as React from 'react';
import './courseListCard2.module.scss';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../../../routes';
import { CourseIndexView } from '../../../../types/courses';
import { ImageApis } from '../../../../../commonv3/api/images';
import { Ribbon } from '../Ribbon';

type Props = {
    course: CourseIndexView;
    styleName?: string;
    className?: string;
};

export class CourseListCard2 extends React.Component<Props> {
    render() {
        const { course, className } = this.props;
        return (
            <Link
                styleName="course-list-card"
                id={`course-list-card-${course.id}`}
                className={className}
                to={V3Routes.course(course.id)}
            >
                <div styleName="background">
                    {course.card_bg && <img styleName="eyecatch-bg" src={ImageApis.getUrlFor(course.card_bg)} />}
                    {course.card_eyecatch && (
                        <img styleName="eyecatch-main" src={ImageApis.getUrlFor(course.card_eyecatch)} />
                    )}
                </div>
                <div styleName="card-main">
                    {course.completed && <Ribbon styleName="ribbon" />}
                    <div styleName="lesson-count">全{course.lesson_count}レッスン</div>
                    <div styleName="title">{course.title}</div>
                    <div styleName="detail-button">
                        詳細をみる<i styleName="icon" className="fa fa-chevron-right" />{' '}
                    </div>
                </div>
            </Link>
        );
    }
}
